import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import dt from "date-and-time";
import dateFormat from "dateformat";
import { FormContext } from 'noood/contexts/contexts';
import Spacer from "../../ui/spacer/Spacer";
import FeatherIcon from "../../ui/feather-icon/FeatherIcon";
import { form_validator } from "../../form/FormFieldValidator";
import CalendarBody from "./CalendarBody";
import Feedback from "../../feedback/Feedback";
import { date_util } from "noood/util/date/DateUtil";
import { ClosestElementRegistryContext } from "noood/contexts/contexts";
import * as stylex from '@stylexjs/stylex';
import { colors } from "noood/styles/colors.stylex.js";
export default function DatePicker(props) {
  var _props$value, _props$validations, _props$validations2, _props$styling, _form_$formObj$props$, _form_$formObj, _form_$formObj2, _form_$formObj$props$2, _form_$formObj3;
  var form_ = useContext(FormContext);
  var closest_ = useContext(ClosestElementRegistryContext);
  var _useState = useState((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : ''),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    set_val = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    e = _useState4[0],
    set_e = _useState4[1];
  var _useState5 = useState(new Date()),
    _useState6 = _slicedToArray(_useState5, 2),
    date_val = _useState6[0],
    set_date_val = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    show = _useState8[0],
    set_show = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    valid_date = _useState0[0],
    set_valid_date = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selected_date = _useState10[0],
    set_selected_date = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    isFocused = _useState12[0],
    setIsFocused = _useState12[1];
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  /* useEffect(() => {
   closest_?.__register?.('#cal-' + props.id, () => {
   set_show(false);
   });
   closest_?.__register?.('#cal-' + props.id + '-tf', () => {
   set_show(false)
   });
   }, [props.id]);*/

  useEffect(function () {
    set_e([]);
    if (val) {
      var _props$format;
      var dt_format = (_props$format = props.format) !== null && _props$format !== void 0 ? _props$format : 'YYYY-MM-DD';
      var parsed_dt = dt.parse(val, dt_format);
      if (!isNaN(parsed_dt)) {
        var _form_$__collect;
        set_date_val(parsed_dt);
        var validation_errors = form_validator.validate(props.validations, val);
        set_e(validation_errors);
        form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, val, validation_errors);
      } else {
        set_e(["Doesn't look like a valid date."]);
        set_date_val(null);
        set_show(false);
      }
    }
  }, [val]);
  useEffect(function () {
    set_val(props.value);
  }, [props.value]);
  var __month = function __month(index) {
    return months[parseInt(index)];
  };
  var __valid_date = function __valid_date(str) {
    var parsed = dt.parse(str, 'YYYY-MM-DD');
    return !isNaN(parsed);
  };

  // useEffect(() => {
  //   set_e(form_?.fieldErrors?.[props.name])
  // }, [form_?.fieldErrors?.[props.name]])

  var this_month = dt.parse(dateFormat(date_val, 'yyyy-mm-01'), 'YYYY-MM-DD');
  var prev_month = dt.addMonths(this_month, -1);
  var prev_month_last_date = dt.addDays(this_month, -1).getDate();
  var next_month = dt.addMonths(this_month, 1);
  var this_month_last_date = dt.addDays(next_month, -1).getDate();
  var day_one = dateFormat(this_month, 'N');
  var this_year_str = dateFormat(this_month, 'yyyy');
  var this_month_str = dateFormat(this_month, 'mm');
  var REQ = ((_props$validations = props.validations) === null || _props$validations === void 0 ? void 0 : _props$validations.indexOf('required')) > -1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label, ((_props$validations2 = props.validations) === null || _props$validations2 === void 0 ? void 0 : _props$validations2.indexOf('required')) > -1 && /*#__PURE__*/React.createElement("span", {
    className: "text-error"
  }, " *")), /*#__PURE__*/React.createElement("div", _extends({
    className: ['ui-datepicker', REQ ? 'required' : ''].join(' '),
    style: _objectSpread({}, (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.box)
  }, stylex.props(ui.thisField, isFocused && ui.focused, REQ && ui.required)), /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: '20px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'calendar'
  }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    id: 'cal-' + props.id + '-tf',
    style: _objectSpread({
      fontSize: '15px',
      padding: '0',
      backgroundColor: "transparent"
    }, props.style),
    className: ['ui-cal-textfield'].join(' '),
    value: (_form_$formObj$props$ = form_ === null || form_ === void 0 || (_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj[props.name]) !== null && _form_$formObj$props$ !== void 0 ? _form_$formObj$props$ : '',
    onFocus: function onFocus() {
      setIsFocused(true);
      if (val) {
        if (!__valid_date(val)) {
          set_date_val(new Date());
        } else {
          var theDate = dt.parse(val, 'YYYY-MM-DD');
          set_date_val(theDate);
          set_val(date_util.format(theDate, 'yyyy-mm-dd'));
        }
      }
      /*closest_?.__close_all()?.then(() => {
       set_show(true)
       })*/
      set_show(true);
    },
    onBlur: function onBlur(e) {
      var _e$nativeEvent, _e$nativeEvent$closes, _e$nativeEvent2, _e$nativeEvent2$close;
      var parent = (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 || (_e$nativeEvent = _e$nativeEvent.explicitOriginalTarget) === null || _e$nativeEvent === void 0 || (_e$nativeEvent$closes = _e$nativeEvent.closest) === null || _e$nativeEvent$closes === void 0 ? void 0 : _e$nativeEvent$closes.call(_e$nativeEvent, '#cal-' + props.id);
      var sibling = (_e$nativeEvent2 = e.nativeEvent) === null || _e$nativeEvent2 === void 0 || (_e$nativeEvent2 = _e$nativeEvent2.relatedTarget) === null || _e$nativeEvent2 === void 0 || (_e$nativeEvent2$close = _e$nativeEvent2.closest) === null || _e$nativeEvent2$close === void 0 ? void 0 : _e$nativeEvent2$close.call(_e$nativeEvent2, '#cal-' + props.id);
      if (parent === null || sibling === null) {
        set_show(false);
      }
      setIsFocused(false);
    },
    onChange: function onChange(e) {
      var _props$__collect;
      var value_validations = form_validator.validate(props.validations, e.target.value);
      if (!__valid_date(e.target.value)) {
        value_validations.push('Not a valid date.');
      }
      set_e(value_validations);
      form_ === null || form_ === void 0 || form_.__collect(props.name, e.target.value, value_validations);
      (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, e.target.value);
    }
  }))), (form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2[props.name]) && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: "x",
    onClick: function onClick() {
      var _form_$__collect2;
      form_ === null || form_ === void 0 || (_form_$__collect2 = form_.__collect) === null || _form_$__collect2 === void 0 || _form_$__collect2.call(form_, props.name, undefined, form_validator.validate(props.validations, undefined));
    }
  })))))), show && /*#__PURE__*/React.createElement(CalendarBody, _extends({}, props, {
    val: (_form_$formObj$props$2 = form_ === null || form_ === void 0 || (_form_$formObj3 = form_.formObj) === null || _form_$formObj3 === void 0 ? void 0 : _form_$formObj3[props.name]) !== null && _form_$formObj$props$2 !== void 0 ? _form_$formObj$props$2 : val,
    set_val: set_val,
    set_show: set_show
  })), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  }), /*#__PURE__*/React.createElement(Feedback, {
    errors: e
  }));
}
DatePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  min_date: PropTypes.string,
  max_date: PropTypes.string,
  __collect: PropTypes.func,
  validations: PropTypes.arrayOf(PropTypes.string),
  styling: PropTypes.shape({
    box: PropTypes.object
  })
};
_inject(".ev70fga0{background-color:var(--shade-field)}", 3000);
_inject(".ev1i3ajwb{padding:2px}", 1000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1bkuceq{border:1px solid var(--shade-20)}", 1000);
_inject(".ev8vmwtk{box-shadow:0 0 0 3px rgba(175,198,255,.51)}", 3000);
_inject(".ev1jqyx15{transition:box-shadow .1s}", 2000);
_inject(".ev1pg6f65{border:1px solid var(--shade-30)}", 1000);
_inject(".ev564o6s{background-color:rgba(250,232,119,.51)}", 3000);
_inject(".ev179f6gg{border-color:var(--ev18ua8hu)}", 2000);
_inject(".ev1y4fvtb{border-width:var(--evntlfdk)}", 2000);
_inject(".ev3vhh18{border-style:var(--ev1a02swc)}", 2000);
var ui = {
  thisField: {
    "DatePicker__ui.thisField": "DatePicker__ui.thisField",
    backgroundColor: "ev70fga0",
    padding: "ev1i3ajwb",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    border: "ev1bkuceq",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  focused: {
    "DatePicker__ui.focused": "DatePicker__ui.focused",
    boxShadow: "ev8vmwtk",
    transition: "ev1jqyx15",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    border: "ev1pg6f65",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  required: {
    "DatePicker__ui.required": "DatePicker__ui.required",
    backgroundColor: "ev564o6s",
    borderColor: "ev179f6gg",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderWidth: "ev1y4fvtb",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev3vhh18",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    $$css: true
  }
};